
@if (ready) {
  <div mat-dialog-title>
    <h2>{{'progression.progression_title' | translate}}</h2>
    @if (!!classControl && !!classControl.value) {
      <label>{{classControl.value?.groupname}}</label>
    }
    @if (!!workgroupControl && !!workgroupControl.value) {
      <label>{{workgroupControl.value?.workgroupname}}</label>
    }
    @if (!!conceptControl) {
      <label>{{conceptControl.value?.get('label')}}</label>
    }
    <!--<ng-container *ngIf="!!classControl">
    <mat-form-field>
      <mat-select
        name="classes"
        [formControl]="classControl">
        <mat-option *ngFor="let class of classes" [value]="class">
          <span>{{class.groupname}}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>-->
  <!--<ng-container *ngIf="!!conceptControl">
  <mat-form-field>
    <mat-select
      name="concept"
      [formControl]="conceptControl">
      <option *ngFor="let concept of concepts" [value]="concept">
        <span>{{concept.get('label')}}</span>
      </option>
    </mat-select>
  </mat-form-field>
</ng-container>-->
<button
  class="close"
  data-e2e="progression-close-dialog"
  (click)="dialogRef.close()"
  aria-label="Close dialog">
  <mat-icon svgIcon="cross"></mat-icon>
</button>
<ul class="breadcrumb">
  @for (chapter of chaptersToDisplay; track chapter) {
    <li [class]="{'selected': isChapterSelected(chapter.id)}">
      <span>{{chapter.label}}</span>
    </li>
  }
</ul>
</div>
<div mat-dialog-content>
  @if (!!currentChapter) {
    <h3>
      <span>{{currentChapter?.get('label')}}</span>
    </h3>
  }
  <section class="list-with-heading">
    <h4>{{lesson?.get('metadatas').title}}</h4>
    <ul>
      @for (subLesson of subLessons; track subLesson; let index = $index) {
        <li data-e2e="progression-select-sub-lesson" (click)="launchAssignment(subLesson)" [class]="{'done': isSubLessonDone(subLesson.id), 'next': isSubLessonAvailable(subLesson, index)}">
          <span>{{subLesson.title}}</span>
          @if (isSubLessonDone(subLesson.id) && !isSubLessonPending(subLesson.id)) {
            <span class="status">
              @if (!!getDateCompleted(subLesson.id)) {
                {{'progression.session_completed' | translate}}&nbsp;
                {{getDateCompleted(subLesson.id) | date: 'dd/MM/yyyy'}}
              }
            </span>
          }
          @if (isSubLessonAvailable(subLesson, index)) {
            <span class="status">{{'progression.sub_lesson_available' | translate}}</span>
          }
        </li>
      }
    </ul>
  </section>
</div>
<div mat-dialog-actions class="progression-action">
  <h3>{{'progression.lets_go' | translate}}</h3>
  <button data-e2e="progression-launch-assignment" [disabled]="!subLessonNotCompleted" (click)="launchAssignment()">
    <mat-icon svgIcon="progression__launch"></mat-icon>
    <span>{{'progression.launch_assignment' | translate}}</span>
  </button>
  <a data-e2e="progression-open-lesson-page" (click)="openLessonPage()" (keydown)="openLessonPageOnEnter($event)" tabindex="0" role="button">{{'progression.prepare_session' | translate}}</a>
  <!--<a href="/">{{'progression.see_all_sessions_completed' | translate}}</a>
  <a href="/">{{'progression.see_the_program_for_the_year' | translate}}</a>-->
</div>
} @else {
  <div class="spinner-wrapper">
    <mat-spinner></mat-spinner>
  </div>
}

